import { Flex, Text } from "@chakra-ui/react";
import useTranslation from "next-translate/useTranslation";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";

interface Props {
  url: string;
}

function ShareButtons({ url }: Props) {
  const { t } = useTranslation("common");

  return (
    <Flex columnGap="8px" alignItems="center" className="share-wrapper">
      <Text marginRight="8px" fontSize="14px" fontWeight="600" color="gray.500">
        {t("ebooks.share")}
      </Text>
      <FacebookShareButton
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "100%",
          display: "flex",
          backgroundColor: "#EDF2F7",
          justifyContent: "center",
          alignItems: "center",
        }}
        url={`${process.env.NEXT_PUBLIC_SITE_URL}/${url}`}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.268 14V9.356H11.8233L12.056 7.55067H10.268V6.39867C10.268 5.876 10.4133 5.51933 11.1627 5.51933H12.1187V3.90467C11.6559 3.85556 11.1907 3.83175 10.7253 3.83333C9.34733 3.83333 8.404 4.67467 8.404 6.22V7.55067H6.84533V9.356H8.404V14H2.66667C2.48986 14 2.32029 13.9298 2.19526 13.8047C2.07024 13.6797 2 13.5101 2 13.3333V2.66667C2 2.48986 2.07024 2.32029 2.19526 2.19526C2.32029 2.07024 2.48986 2 2.66667 2H13.3333C13.5101 2 13.6797 2.07024 13.8047 2.19526C13.9298 2.32029 14 2.48986 14 2.66667V13.3333C14 13.5101 13.9298 13.6797 13.8047 13.8047C13.6797 13.9298 13.5101 14 13.3333 14H10.268V14Z"
            fill="#4267B2"
          />
        </svg>
      </FacebookShareButton>
      <TwitterShareButton
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "100%",
          display: "flex",
          backgroundColor: "#EDF2F7",
          justifyContent: "center",
          alignItems: "center",
        }}
        url={`${process.env.NEXT_PUBLIC_SITE_URL}/${url}`}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.7747 3.77062C14.2657 3.99575 13.726 4.1436 13.1734 4.20928C13.7559 3.86091 14.1918 3.31263 14.4 2.66662C13.8534 2.99195 13.254 3.21995 12.6294 3.34328C12.2098 2.89434 11.6536 2.59659 11.0473 2.49634C10.4411 2.39609 9.81866 2.49895 9.27688 2.78892C8.7351 3.07889 8.30429 3.53974 8.05144 4.09981C7.7986 4.65989 7.73787 5.2878 7.8787 5.88595C6.77011 5.83039 5.68559 5.5423 4.69556 5.04039C3.70553 4.53849 2.83212 3.83398 2.13204 2.97262C1.88423 3.39825 1.75401 3.8821 1.7547 4.37462C1.7547 5.34128 2.2467 6.19528 2.9947 6.69528C2.55204 6.68135 2.11912 6.56181 1.73204 6.34662V6.38128C1.73217 7.02508 1.95495 7.64903 2.3626 8.14732C2.77025 8.64562 3.33769 8.9876 3.9687 9.11528C3.55778 9.22664 3.12691 9.24306 2.7087 9.16328C2.88661 9.71744 3.23337 10.2021 3.70043 10.5494C4.16749 10.8966 4.73145 11.0891 5.31337 11.1C4.73502 11.5542 4.07282 11.8899 3.36462 12.0881C2.65642 12.2862 1.91612 12.3428 1.18604 12.2546C2.4605 13.0742 3.9441 13.5094 5.45937 13.508C10.588 13.508 13.3927 9.25928 13.3927 5.57462C13.3927 5.45462 13.3894 5.33328 13.384 5.21462C13.9299 4.82006 14.4011 4.3313 14.7754 3.77128L14.7747 3.77062Z"
            fill="#1DA1F2"
          />
        </svg>
      </TwitterShareButton>
      <LinkedinShareButton

        style={{
          width: "32px",
          height: "32px",
          borderRadius: "100%",
          display: "flex",
          backgroundColor: "#EDF2F7",
          justifyContent: "center",
          alignItems: "center",
        }}
        url={`${process.env.NEXT_PUBLIC_SITE_URL}/${url}`}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.2233 12.226H10.4467V9.44133C10.4467 8.77733 10.4333 7.92267 9.52 7.92267C8.594 7.92267 8.45267 8.64533 8.45267 9.39267V12.226H6.67533V6.5H8.382V7.28H8.40533C8.644 6.83067 9.224 6.35533 10.0907 6.35533C11.8907 6.35533 12.224 7.54067 12.224 9.08267V12.226H12.2233ZM4.66867 5.71667C4.53304 5.71684 4.39871 5.69025 4.27338 5.6384C4.14804 5.58656 4.03418 5.51049 3.9383 5.41456C3.84243 5.31862 3.76644 5.20471 3.71467 5.07934C3.66291 4.95398 3.6364 4.81963 3.63667 4.684C3.6368 4.47989 3.69745 4.2804 3.81096 4.11076C3.92447 3.94113 4.08573 3.80896 4.27435 3.73097C4.46298 3.65298 4.67049 3.63268 4.87065 3.67263C5.07082 3.71258 5.25464 3.81098 5.39887 3.9554C5.54311 4.09983 5.64128 4.28377 5.68097 4.48399C5.72066 4.6842 5.70009 4.89169 5.62185 5.08021C5.54362 5.26873 5.41125 5.42983 5.24146 5.54311C5.07168 5.6564 4.87211 5.7168 4.668 5.71667H4.66867ZM5.55933 12.226H3.77733V6.5H5.56V12.226H5.55933ZM13.1133 2H2.886C2.39533 2 2 2.38667 2 2.86467V13.1353C2 13.6133 2.396 14 2.88533 14H13.1107C13.6 14 14 13.6133 14 13.1353V2.86467C14 2.38667 13.6 2 13.1107 2H13.1127H13.1133Z"
            fill="#0077B5"
          />
        </svg>
      </LinkedinShareButton>
      <EmailShareButton
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "100%",
          display: "flex",
          backgroundColor: "#EDF2F7",
          justifyContent: "center",
          alignItems: "center",
        }}
        url={`${process.env.NEXT_PUBLIC_SITE_URL}/${url}`}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.99992 2H13.9999C14.1767 2 14.3463 2.07024 14.4713 2.19526C14.5963 2.32029 14.6666 2.48986 14.6666 2.66667V13.3333C14.6666 13.5101 14.5963 13.6797 14.4713 13.8047C14.3463 13.9298 14.1767 14 13.9999 14H1.99992C1.82311 14 1.65354 13.9298 1.52851 13.8047C1.40349 13.6797 1.33325 13.5101 1.33325 13.3333V2.66667C1.33325 2.48986 1.40349 2.32029 1.52851 2.19526C1.65354 2.07024 1.82311 2 1.99992 2V2ZM8.03992 7.78867L3.76525 4.15867L2.90192 5.17467L8.04859 9.54467L13.1026 5.17133L12.2306 4.16267L8.04059 7.78867H8.03992Z"
            fill="#718096"
          />
        </svg>
      </EmailShareButton>
    </Flex>
  );
}

export default ShareButtons;
